import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export const LandingPageSkeleton = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Header Skeleton - NO backdrop-blur to prevent navigation blur */}
      <div className="border-b bg-background">
        <div className="container mx-auto px-4 h-16 flex items-center justify-between">
          <Skeleton className="h-8 w-32" />
          <div className="flex gap-4">
            <Skeleton className="h-8 w-20" />
            <Skeleton className="h-8 w-20" />
            <Skeleton className="h-10 w-32" />
          </div>
        </div>
      </div>

      {/* Hero Skeleton */}
      <div className="container mx-auto px-4 py-12">
        <div className="text-center space-y-4 mb-8">
          <Skeleton className="h-12 w-3/4 mx-auto" />
          <Skeleton className="h-6 w-2/3 mx-auto" />
          <Skeleton className="h-10 w-40 mx-auto mt-6" />
        </div>
      </div>

      {/* Carousel Skeleton */}
      <div className="container mx-auto px-4 py-8">
        <Card className="p-8 max-w-4xl mx-auto">
          <Skeleton className="h-[600px] w-full rounded-lg" />
          <div className="flex justify-center gap-2 mt-4">
            {Array.from({ length: 7 }).map((_, i) => (
              <Skeleton key={i} className="h-2 w-2 rounded-full" />
            ))}
          </div>
        </Card>
      </div>

      {/* Features Grid Skeleton */}
      <div className="container mx-auto px-4 py-12">
        <Skeleton className="h-8 w-48 mx-auto mb-8" />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {Array.from({ length: 6 }).map((_, i) => (
            <Card key={i} className="p-6">
              <Skeleton className="h-12 w-12 rounded-lg mb-4" />
              <Skeleton className="h-6 w-32 mb-2" />
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-3/4 mt-2" />
            </Card>
          ))}
        </div>
      </div>

      {/* Pricing Skeleton */}
      <div className="container mx-auto px-4 py-12">
        <Skeleton className="h-8 w-48 mx-auto mb-8" />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {Array.from({ length: 3 }).map((_, i) => (
            <Card key={i} className="p-6">
              <Skeleton className="h-6 w-24 mb-4" />
              <Skeleton className="h-10 w-32 mb-4" />
              <div className="space-y-2">
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-3/4" />
              </div>
              <Skeleton className="h-10 w-full mt-6" />
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};
